import React from 'react';
import type { FlightType } from '@lt/api/dist/methods/packages/types';

import { FLIGHT_TYPES } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import styled from 'styled-components';
import { Bubble } from '@lt/components';
import { QuestionCircle } from '@lt/components/icons-react';
import { TEST_ID_MOBILE_SUMMARY_FLIGHTS_TYPE } from './constants';

type Props = {
  data: {
    flightType: FlightType;
    flightClass: string;
  };
  showPluralTitle: boolean;
  showFlightClass: boolean;
};

const FlightTypeComponent = ({
  showPluralTitle,
  data,
  showFlightClass,
}: Props) => {
  const { flightType, flightClass } = data;
  const { title, pluralTitle, tooltipDescription } = FLIGHT_TYPES[flightType];
  return (
    <span data-testid={TEST_ID_MOBILE_SUMMARY_FLIGHTS_TYPE}>
      {showPluralTitle ? pluralTitle : title}
      {showFlightClass ? `, ${flightClass}` : '.'}
      <StyledBubble text={tooltipDescription} inline>
        <StyledQuestionCircle />
      </StyledBubble>
    </span>
  );
};

const StyledBubble = styled(Bubble)`
  margin-left: 4px;
`;

const StyledQuestionCircle = styled(QuestionCircle).attrs({
  width: '14px',
  height: '14px',
})`
  stroke: #919499;
  cursor: pointer;

  > path {
    stroke-width: 0.5;
    fill: #919499;
  }
`;

export default FlightTypeComponent;
